<template>
  <div>

<b-container class="side-n"  >
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('whoweare')" block squared id="bwhoweare" class=" btn-color btn-color-active">
        আমাৰ পৰিচয়
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('regoffice')" block squared id="bregoffice" class=" btn-color ">
        পঞ্জীভুক্ত কাৰ্যালয়
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('profile')" block squared id="bprofile" class=" btn-color">
        কোম্পানীৰ সংক্ষিপ্ত
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('glance')" block squared id="bglance" class=" btn-color">
      চকুৰ পচাৰতে এপিডিচিএল
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('Mandate')" block squared id="bMandate" class=" btn-color">
      কোম্পানীৰ বিধান</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button  @click="goto('vision')" block squared id="bvision" class=" btn-color">
      আমাৰ ভৱিষ্যদৰ্শন</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('mission')" block squared id="bmission" class=" btn-color">
      আমাৰ লক্ষ্য</b-button></b-col>
  </b-row>
 <!-- <b-row class="custom-row">
    <b-col ><b-button @click="goto('minister')" block squared id="bminister" class=" btn-color">
    মন্ত্ৰী</b-button></b-col>
  </b-row>-->
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('bod')" block squared id="bbod" class=" btn-color">
    সঞ্চালক মণ্ডলী
  </b-button></b-col>
  </b-row>

  <!-- <b-row class="custom-row">
    <b-col ><b-button @click="goto('chairmsg')" block squared id="bchairmsg" class=" btn-color">
      Chairman's Message</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('mdmsg')" block squared id="bmdmsg" class=" btn-color">
      MD's Message</b-button></b-col>
  </b-row> -->

<!-- <b-row class="custom-row">
    <b-col ><b-button @click="goto('kofficial')" block squared id="bkofficial" class=" btn-color">
    Key Officials</b-button></b-col>
  </b-row> -->
  <!--<b-row class="custom-row" style="  height:60px;">
    <b-col ><b-button @click="goto('jobchart')" block squared id="bjobchart" class=" btn-color" >
    চাকৰিৰ চনদ আৰু মূল বিষয়াবৃন্দৰ দায়িত্ব</b-button></b-col>
  </b-row>-->
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('adminh')" block squared id="badminh" class=" btn-color">
    প্ৰশাসনীয় বৰ্গীকৰণ</b-button></b-col>
  </b-row>
  <!-- <b-row class="custom-row">
    <b-col ><b-button @click="goto('scaleop')" block squared id="bscaleop" class=" btn-color">
    Scale of Operations</b-button></b-col>
  </b-row> -->
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('gmap')" block squared id="bgmap" class=" btn-color">
  ভৌগোলিক মানচিত্ৰ
 </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('pmap')" block squared id="bpmap" class=" btn-color">
    শক্তি মানচিত্ৰ
  </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col>
      <a  href="https://www.apdcl.org/website/docs/about/ISO_Certificate.pdf" target="_blank">
      <b-button block squared id="" class=" btn-color">
    আই এচ অ’ প্ৰমাণ পত্ৰ
  </b-button>
  </a>
</b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col >
      <a  href="https://www.apdcl.org/website/docs/about/Quality_Policy.pdf" target="_blank">
    <b-button  block squared variant="" class=" btn-color">
    গুণাগুণ নীতি
  </b-button>
</a>
  </b-col>
  </b-row>
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
  goto(refName) {
     var element=document.getElementById(refName);
     var btn_id='b' + refName;
     var btn=document.getElementById(btn_id);
     element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });
     document.querySelector(".btn-color-active").classList.remove("btn-color-active");
     btn.classList.add("btn-color-active");
     // document.getElementsByClassName("btn-color-active").classList.remove("btn-color-active");
   }
  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;

 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd       ;
  border-color: #0277bd       ;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1     ;
  border-color: #0288d1     ;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}

</style>
